// eslint-disable-next-line
const constants = module.exports = Object.freeze({
    CATALOGS: [
        {
            type: 'managers',
            url: null,
        },
        {
            type: 'payTypes',
            url: 'pay-types',
        },
        {
            type: 'orderStatuses',
            url: 'order-statuses',
        },
        {
            type: 'payStatuses',
            url: 'pay-statuses',
        },
        {
            type: 'deliveryServiceTypes',
            url: 'delivery-service-types',
        },
        {
            type: 'deliveryServiceMethods',
            url: 'delivery-service-methods',
        },
        {
            type: 'orderTypes',
            url: 'order-types',
        },
        {
            type: 'subscriptionTypes',
            url: 'subscription-type',
        },
        {
            type: 'deliveryServices',
            url: 'delivery-services',
        },
        {
            type: 'deliveryStatuses',
            url: 'delivery-statuses',
        },
        {
            type: 'receiveStatuses',
            url: 'receive-statuses',
        },
        {
            type: 'tareTypes',
            url: 'tare-types',
        },
        {
            type: 'waitReasons',
            url: 'wait-reasons',
        },
        {
            type: 'orderSourceTypes',
            url: 'order-source-types',
        },
        {
            type: 'currency',
            url: 'currency',
        },
        {
            type: 'customerRequests',
            url: 'customer-requests',
        },
        {
            type: 'stockTypes',
            url: 'stock-types',
        },
        {
            type: 'eventHandlers',
            url: 'event-handlers',
        },
        {
            type: 'cancelReasons',
            url: 'cancel-reasons',
        },
        {
            type: 'languages',
            url: 'languages',
        },
        {
            type: 'confirmationCodeStatuses',
            url: 'confirmation-code-statuses',
        },
        {
            type: 'documentTypes',
            url: 'document-types',
        },
        {
            type: 'promos',
            url: 'promos',
        },
        {
            type: 'changeReasons',
            url: 'change-reasons',
        },
        {
            type: 'taskTypes',
            url: 'task-types',
        },
        {
            type: 'actionIfNotValidate',
            url: 'action-if-not-validate',
        },
        {
            type: 'taskExpiredCategory',
            url: 'task-expired-category',
        },
        {
            type: 'helpPageSections',
            url: 'help-page-sections',
        },
        {
            type: 'helpPages',
            url: 'help-pages',
        },
        {
            type: 'deliveryServiceRule',
            url: 'delivery-service-rule',
        },
    ],

    REQUEST_STATUS: {
        fulfilled: 'fulfilled',
    },

    ERROR_CODES: {
        incorrectPfm: 50,
        isNotAvailableOnMobile: 286,
        pageNotFound: 1,
        actionDenied: 19,
        accessDenied: 326,
        incorrectData: 7,
        changeStatus: 45,
        notActualOrderVersion: 355,
        failedToUpdateTheStamps: 390,
        taskNotFound: 404,
        invalidProductChangeReason: 411,
        deliveryTare: {
            exceedingMoreThan2Boxes: 445,
            exceedingMoreThan1LargeBox: 446,
        },
    },

    REQUEST_HEADERS: {
        xOrderUpdateTime: 'x-order-update-time',
        xBrowserTabId: 'x-browser-tab-id',
    },

    ROUTES: {
        AccessDenied: {
            path: '/access-denied',
            name: 'AccessDenied',
        },

        Orders: {
            path: '/orders',
            name: 'Orders',
        },
    },

    HTTP_STATUSES: {
        ok: 200,
        badRequest: 400,
        unprocessableContent: 422,
    },

    CACHE_TTL: {
        twoMinutes: 120000,
        oneWeek: 604800000,
    },

    ROW_VARIANT_INACTIVE: 'inactive',

    COUNTRIES: ['RU', 'BY', 'KZ', 'LV', 'AE'],

    LANGUAGES: ['ru', 'kk', 'en'],

    INT32_MAX: 2147483647,
    MILLISECONDS_PER_MINUTE: 60000,
    VAT: 22,
});